export enum FileExtensionEnum {
    CSV = 0,
    XLS = 1,
    XLSX = 2,
    PDF = 3,
    DOC = 4,
    DOCX = 5,
    HTML = 6,
    TXT = 7
}